/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetCostChangeQueryResult } from '../../models/get-cost-change-query-result';

export interface ApiProjectCostChangeGetCostChangeGet$Params {
  Id: string;
}

export function apiProjectCostChangeGetCostChangeGet(http: HttpClient, rootUrl: string, params: ApiProjectCostChangeGetCostChangeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<GetCostChangeQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCostChangeGetCostChangeGet.PATH, 'get');
  if (params) {
    rb.query('Id', params.Id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetCostChangeQueryResult>;
    })
  );
}

apiProjectCostChangeGetCostChangeGet.PATH = '/api/ProjectCostChange/GetCostChange';
